import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { designHuddleService } from 'services';

export const useCreateExportProjectJob = (refetchHistory?: boolean) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({
      clinid,
      projectId,
      format,
      sku,
      shouldCreatDownloadHistory,
    }: {
      clinid: string | undefined;
      projectId: string;
      format: string;
      sku?: string;
      shouldCreatDownloadHistory?: boolean;
    }) => {
      return designHuddleService.createExportProjectJob(
        clinid,
        projectId,
        format,
        sku,
        shouldCreatDownloadHistory
      );
    },
    {
      onSuccess: () => {
        if (refetchHistory) {
          queryClient.invalidateQueries([ServerStateKeysEnum.downloadsHistory]);
          queryClient.invalidateQueries({
            queryKey: [ServerStateKeysEnum.marketingProjects],
          });
        }
      },
    }
  );
};
